import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Events from './pages/Events';
import Schedule from './pages/schedule';
import Sponsor from './pages/sponsor';  // Make sure the path is correct
import Contact from './pages/contact';
import Meet from './pages/Meet';
import Membership from './pages/Membership';
import Membershipone from './pages/Membershipact';
import Nopage from './pages/nopage';
// import Loader from './Components/loader'; 
import './App.css';


function App() {
  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setLoading(false);
  //   }, 2000); // Simulate a loading delay

  //   return () => clearTimeout(timer);
  // }, []);

  // if (loading) {
  //   return <Loader />;
  // }

  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route index element={<Home />}/>
          <Route path="/home" element={<Home />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/events" element={<Events />} />
          <Route path="/sponsor" element={<Sponsor />} />
          <Route path="/meet" element={<Meet />} />
          <Route path="/membershipact" element={<Membership />} />
          <Route path="/membership" element={<Membershipone />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Nopage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;